import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const approvalFlowSuccessorFields = `
id
successorUniqueId
successorCurrentStage {
  id
  stageUniqueId
  stageName
  stageIsStarting
  stageIsEnding
  stageDesignation {
    id
    designationUniqueId
    designationShortForm
    designationName
  }
}
successorStage {
  id
  stageUniqueId
  stageName
  stageIsStarting
  stageIsEnding
}
`
;



export const DELETE_APPROVAL_SUCCESSOR = gql`
mutation deleteApprovalFlowStagesSuccessorMutation($successorUniqueId: String!) {
  deleteApprovalFlowStagesSuccessorMutation(successorUniqueId: $successorUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`
